import { useTranslation } from "react-i18next";import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { cn } from '@/shared/utils';

export const FinanceStatCard = ({
  title,
  value,
  icon: Icon,
  color = 'emerald',
  subtitle,
  trend,
  prefix = '',
  suffix = '',
  className
}) => {const { t } = useTranslation("finance");
  const colorMap = {
    emerald: 'bg-emerald-500/10 text-emerald-600',
    green: 'bg-green-500/10 text-green-600',
    gold: 'bg-amber-500/10 text-amber-600',
    red: 'bg-red-500/10 text-red-600',
    blue: 'bg-blue-500/10 text-blue-600',
    purple: 'bg-purple-500/10 text-purple-600'
  };

  const borderColorMap = {
    emerald: 'border-l-emerald-500',
    green: 'border-l-green-500',
    gold: 'border-l-amber-500',
    red: 'border-l-red-500',
    blue: 'border-l-blue-500',
    purple: 'border-l-purple-500'
  };

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return prefix + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + suffix;
    }
    return prefix + val + suffix;
  };

  return (
    <Card className={cn(
      "card-elevated border-l-4 transition-all duration-200 hover:shadow-lg",
      borderColorMap[color],
      className
    )}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
              {title}
            </p>
            <p className="text-2xl font-bold mt-2 text-foreground font-['Space_Grotesk']">
              {formatValue(value)}
            </p>
            {subtitle &&
            <p className="text-sm text-muted-foreground mt-1">
                {subtitle}
              </p>
            }
            {trend &&
            <p className={cn(
              "text-sm mt-1 font-medium flex items-center gap-1",
              trend.type === 'up' ? 'text-emerald-600' : 'text-red-600'
            )}>
                <span>{trend.type === 'up' ? '↑' : '↓'}</span>
                <span>{trend.value}%</span>
                {trend.label && <span className="text-muted-foreground font-normal">{t("vsLastPeriod", "vs last period")}</span>}
              </p>
            }
          </div>
          {Icon &&
          <div className={cn(
            "flex h-12 w-12 items-center justify-center rounded-xl",
            colorMap[color]
          )}>
              <Icon className="h-6 w-6" />
            </div>
          }
        </div>
      </CardContent>
    </Card>);

};